import { gql } from '@apollo/client';

const GET_CHATS = {
  query: gql`
    query GetChats($driverId: ID!, $limit: Int, $offset: Int, $caseStatus: String) {
      getChats(driverId: $driverId, limit: $limit, offset: $offset, caseStatus: $caseStatus) {
        total
        limit
        offset
        chats {
          conversationIdentifier
          caseStatus
          caseSubject
          caseNumber
        }
      }
    }
  `,
  policies: {
    fetchPolicy: 'no-cache',
  },
};

export default GET_CHATS;
